import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	output,
} from '@angular/core';
import { ClearingToggleComponent } from '../clearing-toggle/clearing-toggle.component';
import { Product, ProductEnum } from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-filter-clearing-toggle',
	imports: [ClearingToggleComponent],
	templateUrl: './filter-clearing-toggle.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterClearingToggleComponent {
	product = input.required<Product>();
	description = input.required<string>();
	heading = input('Show Courses in Clearing');

	changeClearingChecked = output<boolean>();

	formattedDesc = computed(() => {
		const desc = this.description();
		return desc.replace('[YEAR]', new Date().getFullYear().toString());
	});

	isPG = computed(() => this.product() === ProductEnum.Postgraduate);
	isCLE = computed(() => this.product() === ProductEnum.Clearing);
}
